module.exports = __webpack_public_path__ + "static/media/calendar-event-line.71c11e49.svg";